export const ApiPath = {
  auth: {
    login: '/v1/admin/web-authentication/login',
    getUserData: '/v1/admin/web-authentication/get-user-data',
    resetPassword: '/v1/admin/web-authentication/reset-password',
    refreshToken: '/v1/admin/web-authentication/refresh-token',
  },
  appUsers: {
    all: '/v1/admin/app-users/all',
    create: '/v1/admin/app-users/create',
    update: (id: string) => `/v1/admin/app-users/update/${id}`,
    delete: (id: string) => `/v1/admin/app-users/delete/${id}`,
  },
  webappUsers: {
    all: '/v1/admin/webapp-users/all',
    findOne: (uuid: string) => `/v1/admin/webapp-users/find-one/${uuid}`,
    create: '/v1/admin/webapp-users/create',
    update: (id: string) => `/v1/admin/webapp-users/update/${id}`,
    delete: (id: string) => `/v1/admin/webapp-users/delete/${id}`,
    addFcmToken: '/v1/admin/webapp-users/add-fmc-token',
  },
  documents: {
    all: '/v1/admin/documents/all',
    create: '/v1/admin/documents',
    update: (id: string) => `/v1/admin/documents/update/${id}`,
    updateDescription: (uuid: string) => `/v1/admin/documents/update-description/${uuid}`,
    delete: (id: string) => `/v1/admin/documents/delete/${id}`,
    bulkDelete: '/v1/admin/documents/bulk-delete',
    statusCounts: '/v1/admin/documents/status-counts',
  },
  destinations: {
    all: '/v1/admin/destinations/all',
    appAll: '/v1/admin/destinations/app-all',
    create: '/v1/admin/destinations',
    updateStatus: (id: string) => `/v1/admin/destinations/update-status/${id}`,
    delete: (uuid: string) => `/v1/admin/destinations/delete/${uuid}`,
  },
  documentType: {
    all: '/v1/admin/document-types/all',
    create: '/v1/admin/document-types/create',
    update: (id: string) => `/v1/admin/document-types/update/${id}`,
    delete: (id: string) => `/v1/admin/document-types/delete/${id}`,
  },
  documentTypeCategory: {
    all: '/v1/admin/document-type-category/all',
  },
  positions: {
    all: '/v1/admin/positions/all',
    create: '/v1/admin/positions/create',
    update: (id: string) => `/v1/admin/positions/update/${id}`,
    delete: (id: string) => `/v1/admin/positions/delete/${id}`,
  },
  positionCategory: {
    all: '/v1/admin/position-category/all',
    create: '/v1/admin/position-category/create',
    update: (id: string) => `/v1/admin/position-category/update/${id}`,
    delete: (id: string) => `/v1/admin/position-category/delete/${id}`,
  },
  provinces: {
    all: '/v1/admin/provinces/all',
    create: '/v1/admin/provinces/create',
    update: (id: string) => `/v1/admin/provinces/update/${id}`,
    delete: (id: string) => `/v1/admin/provinces/delete/${id}`,
  },
  ministries: {
    all: '/v1/admin/ministries/all',
    create: '/v1/admin/ministries/create',
    update: (id: string) => `/v1/admin/ministries/update/${id}`,
    delete: (id: string) => `/v1/admin/ministries/delete/${id}`,
  },
  notifications: {
    all: '/v1/admin/notifications/all',
    delete: (id: string) => `/v1/admin/notifications/delete/${id}`,
  },
  trackingTimeline: {
    all: '/v1/admin/tracking-timeline/all',
  },
  globalCache: {
    health: '/v1/admin/global-cache/health',
    stats: '/v1/admin/global-cache/stats',
    statsByModule: (moduleKey: string) => `/v1/admin/global-cache/stats/${moduleKey}`,
    modules: '/v1/admin/global-cache/modules',
    operations: '/v1/admin/global-cache/operations',
    clearModule: '/v1/admin/global-cache/clear/module',
    clearKeys: '/v1/admin/global-cache/clear/keys',
    clearAllModules: '/v1/admin/global-cache/clear/all-modules',
  },
  health: {
    clearAllCaches: '/v1/health/clear-caches/all',
  },
  appVersion: {
    all: '/v1/admin/app-version/all',
    create: '/v1/admin/app-version/create',
    update: (uuid: string) => `/v1/admin/app-version/update/${uuid}`,
    delete: (uuid: string) => `/v1/admin/app-version/delete/${uuid}`,
  },
  departments: {
    all: '/v1/admin/departments/all',
    create: '/v1/admin/departments/create',
    update: (uuid: string) => `/v1/admin/departments/update/${uuid}`,
    delete: (uuid: string) => `/v1/admin/departments/delete/${uuid}`,
  },
  roles: {
    all: '/v1/admin/roles/all',
    findOne: (id: number) => `/v1/admin/roles/find-one/${id}`,
    create: '/v1/admin/roles/create',
    update: (id: number) => `/v1/admin/roles/update/${id}`,
    delete: (id: number) => `/v1/admin/roles/delete/${id}`,
  },
  permissions: {
    all: '/v1/admin/permissions/all',
    findOne: (uuid: string) => `/v1/admin/permissions/find-one/${uuid}`,
    create: '/v1/admin/permissions/create',
    update: (uuid: string) => `/v1/admin/permissions/update/${uuid}`,
    delete: (uuid: string) => `/v1/admin/permissions/delete/${uuid}`,
  },
  rolePermissions: {
    all: '/v1/admin/role-permissions/all',
    create: '/v1/admin/role-permissions/create',
    bulkCreate: '/v1/admin/role-permissions/bulk-create',
    update: (uuid: string) => `/v1/admin/role-permissions/update/${uuid}`,
    delete: (uuid: string) => `/v1/admin/role-permissions/delete/${uuid}`,
  },
  reports: {
    summary: '/v1/admin/reports/summary',
  },
};
